import { css, extractTransition, Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  body: css`
    display: flex;
    flex-direction: column;
    gap: 24px;
  `,
  radioGroup: css`
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 24px;

    & > label {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 8px;
    }
  `,
  radioSelectionResult: css`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
  `,
  radioItem: ({ theme }) => css`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    gap: 0;

    padding: 8px;
    border-radius: 8px;
    border: 1px solid ${theme.colors.neutral.variant[20]};
    color: ${theme.colors.neutral.variant[70]};

    height: 100px;
    width: 100%;

    ${extractTransition((f) => f.cubic, { duration: 200, property: ['border-color', 'background-color'] })}

    & > svg {
      flex-shrink: 0;
      margin-bottom: 8px;
    }

    &:hover {
      border-color: ${theme.colors.neutral.variant[30]};
    }
  `,
  meetingDuration: ({ theme }) => css`
    position: absolute;
    top: 0px;
    right: 0px;
    transform: translateY(-25%) translateX(25%);
    background: white;
    border-radius: 12px;
    border: 1px solid ${theme.colors.neutral.variant[20]};
    color: ${theme.colors.neutral.variant[70]};
    padding: 2px 4px;
  `,
  meetingDurationSelected: ({ theme }) => css`
    border-color: ${theme.colors.primary.fuchsia[30]};
    color: ${theme.colors.primary.fuchsia[50]};
  `,
  radioItemSelected: ({ theme }) => css`
    &,
    &:hover {
      color: ${theme.colors.primary.fuchsia[50]};
      border-color: ${theme.colors.primary.fuchsia[30]};
      background-color: ${theme.colors.neutral.variant[10]};
    }
  `,
  loader: css`
    margin: 0 auto;
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
